import { EUserRole } from '../../../share/share-utils/user-roles';

// TODO: use EUserRole as type instead of string
export function checkIfCellEditable(shareOption: string): boolean {
  return shareOption !== EUserRole.SITE_ADMIN && shareOption !== EUserRole.ACCOUNT_ADMIN;
}
